module.exports = __webpack_public_path__ + "static/media/news_icon.74c2d3d1.svg";